import React from 'react';
import { Alert, Container } from 'react-bootstrap';

function Unauthorized() {
  localStorage.clear();
  return (
    <Container className="mt-5">
      <Alert variant="danger">
        <h2>Unauthorized</h2>
        <p>You do not have permission to access this page.</p>
      </Alert>
    </Container>
  );
}

export default Unauthorized;